module.exports = __webpack_public_path__ + "img/Mauritius.2e6c0d35.png";